import { css } from '@linaria/core';
export const Root = {
    base: css `
		position: inherit;

		display: flex;
		align-items: center;
		justify-content: center;

		width: 100%;
	`,
};
export const Circle = {
    base: css `
		position: relative;
		animation: loading 2000ms var(--global-ease-in-out);

		@keyframes loading {
			0% {
				opacity: 0;
			}
			100% {
				opacity: 1;
			}
		}
	`,
};
export const Animation = {
    base: css `
		position: absolute;
		left: 50%;

		width: var(--loadingIndicator-sizing-width-base);
		height: var(--loadingIndicator-sizing-width-base);
		margin-top: calc(var(--loadingIndicator-sizing-width-base) / -2);
		margin-left: calc(var(--loadingIndicator-sizing-width-base) / -2);
		border-radius: var(--loadingIndicator-corner-radius-all);

		opacity: 0;
		background: rgb(var(--loadingIndicator-color-base));

		animation:
			cs-Loading-Animation-scale 2500ms var(--global-ease-out) infinite,
			cs-Loading-Animation-opacity 2500ms linear infinite;

		@keyframes cs-Loading-Animation-scale {
			from {
				transform: scale(0);
			}
			to {
				transform: scale(1);
			}
		}

		@keyframes cs-Loading-Animation-opacity {
			from {
				opacity: 1;
			}
			to {
				opacity: 0;
			}
		}
	`,
};
export const Animation2 = {
    base: css `
		position: absolute;
		left: 50%;

		width: var(--loadingIndicator-sizing-width-base);
		height: var(--loadingIndicator-sizing-width-base);
		margin-top: calc(var(--loadingIndicator-sizing-width-base) / -2);
		margin-left: calc(var(--loadingIndicator-sizing-width-base) / -2);
		border-radius: var(--loadingIndicator-corner-radius-all);

		opacity: 0;
		background: rgb(var(--loadingIndicator-color-base));

		animation: cs-Loading-Animation-scale 2500ms var(--global-ease-out) infinite;
		animation-delay: 300ms;
	`,
};
export const Animation3 = {
    base: css `
		position: absolute;
		left: 50%;

		width: var(--loadingIndicator-sizing-width-base);
		height: var(--loadingIndicator-sizing-width-base);
		margin-top: calc(var(--loadingIndicator-sizing-width-base) / -2);
		margin-left: calc(var(--loadingIndicator-sizing-width-base) / -2);
		border-radius: var(--loadingIndicator-corner-radius-all);

		opacity: 0;
		background: rgb(var(--loadingIndicator-color-base));

		animation: cs-Loading-Animation-scale 2500ms var(--global-ease-out) infinite;
		animation-delay: 600ms;
	`,
};
